var _rect, _mask, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnmuteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "white",
    fillOpacity: 0.3
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_13463_167",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 18.5133V15.1486C6 13.9652 6.95939 13.0058 8.14286 13.0058H13.5159L18.7921 9.13942C19.2639 8.79366 19.9286 9.13061 19.9286 9.71557V27.3111C19.9286 27.8961 19.2639 28.233 18.7921 27.8873L13.1053 23.7201H8.14286C6.95939 23.7201 6 22.7607 6 21.5772V18.5133Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 18.5133V15.1486C6 13.9652 6.95939 13.0058 8.14286 13.0058H13.5159L18.7921 9.13942C19.2639 8.79366 19.9286 9.13061 19.9286 9.71557V27.3111C19.9286 27.8961 19.2639 28.233 18.7921 27.8873L13.1053 23.7201H8.14286C6.95939 23.7201 6 22.7607 6 21.5772V18.5133Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5159 13.0058V14.4344C13.8195 14.4344 14.1153 14.3376 14.3603 14.1581L13.5159 13.0058ZM18.7921 9.13942L17.9477 7.98711L17.9477 7.98711L18.7921 9.13942ZM18.7921 27.8873L17.9477 29.0396H17.9477L18.7921 27.8873ZM13.1053 23.7201L13.9497 22.5678C13.7048 22.3883 13.409 22.2915 13.1053 22.2915V23.7201ZM7.42857 18.5133V15.1486H4.57143V18.5133H7.42857ZM7.42857 15.1486C7.42857 14.7541 7.74837 14.4344 8.14286 14.4344V11.5772C6.17041 11.5772 4.57143 13.1762 4.57143 15.1486H7.42857ZM8.14286 14.4344H13.5159V11.5772H8.14286V14.4344ZM14.3603 14.1581L19.6365 10.2917L17.9477 7.98711L12.6715 11.8535L14.3603 14.1581ZM19.6365 10.2917C19.1647 10.6375 18.5 10.3005 18.5 9.71557H21.3571C21.3571 7.96069 19.3632 6.94985 17.9477 7.98711L19.6365 10.2917ZM18.5 9.71557V27.3111H21.3571V9.71557H18.5ZM18.5 27.3111C18.5 26.7262 19.1646 26.3892 19.6365 26.735L17.9477 29.0396C19.3632 30.0768 21.3571 29.066 21.3571 27.3111H18.5ZM19.6365 26.735L13.9497 22.5678L12.2609 24.8724L17.9477 29.0396L19.6365 26.735ZM13.1053 22.2915H8.14286V25.1486H13.1053V22.2915ZM8.14286 22.2915C7.74837 22.2915 7.42857 21.9717 7.42857 21.5772H4.57143C4.57143 23.5497 6.17041 25.1486 8.14286 25.1486V22.2915ZM7.42857 21.5772V18.5133H4.57143V21.5772H7.42857Z",
    fill: "black",
    mask: "url(#path-2-inside-1_13463_167)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8571 10.4286V10.4286C27.9073 14.8838 27.9073 21.6877 23.8571 26.1429V26.1429",
    stroke: "black",
    strokeWidth: 1.42857,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7143 13.2857V13.2857C24.3559 16.1305 24.4309 20.5082 21.8884 23.4419L21.7143 23.6428",
    stroke: "black",
    strokeWidth: 1.42857,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnmuteIcon);
export default __webpack_public_path__ + "static/media/unmuteIcon.cf28d2c0a78ab8e97cb7085910c9e324.svg";
export { ForwardRef as ReactComponent };